import React, { ReactNode, useEffect, useState } from "react";

import { BasicTabs } from "minimum-ui/core";

export interface UploadTabProps {
  label: string;
  render: () => ReactNode;
}

interface UploadTabsProps {
  tabs: UploadTabProps[];
  activeTabIndex?: number;
  onTabChange?: (newTabIndex: number) => void;
  onBeforeTabChange?: (nextTabIndex: number) => void;
}

const UploadTabs: React.FC<UploadTabsProps> = ({
  tabs,
  activeTabIndex = 0,
  onTabChange,
  onBeforeTabChange,
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(activeTabIndex);

  // Effect to handle tab change
  useEffect(() => {
    if (onTabChange) {
      onTabChange(activeIndex);
    }
  }, [activeIndex, onTabChange]);

  const handleTabClick = (index: number) => {
    onBeforeTabChange?.(index);
    setActiveIndex(index);
  };

  return (
    <BasicTabs
      tabs={tabs}
      activeTabIndex={activeIndex}
      onTabChange={handleTabClick}
    />
  );
};

export default UploadTabs;
